<template>
  <slot :download="openModal" data-cy="modal-open-slot" />
  <Dialog
    v-model:visible="isModalOpen"
    header="Syncing Equipment"
    :modal="true"
    :closable="false"
    data-cy="syncing-equipment-dialog"
  >
    <EquipmentLoaderModalDisplay
      v-if="isDownloading"
      data-cy="equipment-loader-modal-display"
      @complete="closeModal(true)"
    />

    <template #footer>
      <Button
        label="Cancel"
        class="p-button-info"
        data-cy="cancel-button"
        @click="closeModal(false)"
      />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from "primevue/dialog";
import { nextTick, ref } from "vue";
import EquipmentLoaderModalDisplay from "./EquipmentLoaderModalDisplay.vue";
import { useToast } from "primevue/usetoast";

const isModalOpen = ref(false);
const isDownloading = ref(false);
const toaster = useToast();

function openModal() {
  isModalOpen.value = true;
  nextTick(() => {
    isDownloading.value = true;
  });
}

function closeModal(hasCompleted = true) {
  toaster.add({
    severity: "success",
    life: 8000,
    summary: hasCompleted ? "Sync Complete" : "Sync Cancelled"
  });
  isDownloading.value = false;
  isModalOpen.value = false;
}
</script>
